export default "__VITE_ASSET__D2ok05E9__"